import React, { Component } from 'react';
import Vas from '../Vas';
import '../css/Order.css';


class LogoutSuccess extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};

        //Hier die Angaben zur Vertragsanlage löschen, da der Dokumentenupload ebenfalls erfolgreich war
        localStorage.removeItem("CustomerId");
        localStorage.removeItem("ContractNUmber");
        localStorage.removeItem("ExecutingForm");
        localStorage.removeItem("CustomerAboveId")

    }

    componentDidMount(){
      this.TimeOutTime = window.setTimeout(function(){
        Vas.GetView("Tariffing",null,false);
      },5000);
    }

   render()
    {

      return ( <div className="LoginContainer">

      <div className={"form orderSuccessForm"} style={{ Width:'560px' }}>
        <table>
          <thead>
            <tr>
              <th colSpan={2}><h2 id={"OrderSuccessHeader"}>{Vas.Resources.Labels["LogoutSuccess"]}</h2></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{Vas.Resources.Labels["LinkInShortTime"]}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>);
    }
}
export default LogoutSuccess;
